/** Per Compare modal / coaching semantics: whether a higher raw KPI value is “better”. */
export const KPI_HIGHER_IS_BETTER = {
  re: true,
  stride: true,
  paceBpm: false,
  bpmWatt: false,
  paceWatt: false,
  elevKm: false,
  calKm: false,
};
